export default {
  namespaced: true,
  state: () => ({
    id_number: '',
    firstname: '',
    lastname: '',
    gender: '',
    birthdate: null,
    country_code: '',
    phone_number: '',
    password: '',
    password_confirm: '',
    agreed: false,
    try: 0,
    errors: {}
  }),
  getters: {
    id_number: state => state.id_number,
    firstname: state => state.firstname,
    lastname: state => state.lastname,
    gender: state => state.gender,
    birthdate: state => state.birthdate,
    country_code: state => state.country_code,
    phone_number: state => state.phone_number,
    password: state => state.password,
    password_confirm: state => state.password_confirm,
    agreed: state => state.agreed,
    try: state => state.try,
    errors: state => state.errors,
    step: state => {
      if (!state.firstname || !state.lastname) {
        return 1
      }
      if (!state.gender || !state.birthdate) {
        return 2
      }
      if (!state.country_code || !state.phone_number || !state.password || !state.password_confirm || !state.agreed) {
        return 3
      }
      if (state.password.length > 6 && state.password === state.password_confirm) {
        return 4
      }
      return null
    }
  },
  mutations: {
    trySubmit (state) {
      state.try++
    },
    setid_number (state, id_number) {
      state.id_number = id_number
    },
    setFirstname (state, firstname) {
      state.firstname = firstname
    },
    setLastname (state, lastname) {
      state.lastname = lastname
    },
    setGender (state, gender) {
      state.gender = gender
    },
    setBirthdate (state, birthdate) {
      state.birthdate = birthdate
    },
    setcountry_code (state, country_code) {
      state.country_code = country_code
    },
    setphone_number (state, phone_number) {
      state.phone_number = phone_number
    },
    setPassword (state, password) {
      state.password = password
    },
    setpassword_confirm (state, password_confirm) {
      state.password_confirm = password_confirm
    },
    setAgreed (state, agreed) {
      state.agreed = agreed
    }
  }
}
